module.exports = __webpack_public_path__ + "img/jpg.b47214c.svg";